import { AppCoreEnums } from '../shared/enums';
import { useCoreStore } from '../../stores/core/store';
import { ComputedRef, Ref, computed, toRaw } from 'vue';
import useUserPreferences from './use-user-preferences';
import { saveUserPreference } from '../utils/user-preferences-utils';
import { AppTableColumnSelection, IColumn } from '../../stores/core/models';

export default (containerType: ComputedRef<AppCoreEnums.ContainerType>) => {
  const coreStore = useCoreStore();
  const { getTableColumnsPreferenceKey } = useUserPreferences();

  const columnDefs = computed(() => coreStore.getTableBasedContainerData(containerType.value).value?.options?.columns || []);
  const key = computed(() => getTableColumnsPreferenceKey(containerType.value));

  const columnsFromUserPreference = computed(
    () => JSON.parse(coreStore.getUserPreferenceByKey(key.value).value || '[]') as AppTableColumnSelection[]
  );

  const allColumns = computed(() => {
    const columnsDef = [...toRaw(columnDefs.value)];
    let result = [] as IColumn[];

    if (columnsFromUserPreference.value.length) {
      columnsFromUserPreference.value.forEach((x) => {
        const related = columnsDef.find((y) => y.field == x.name);
        if (related) {
          related.isVisible = x.isColumnVisible;
          result.push(related);
        }
      });
    } else {
      result = columnsDef;
      result.forEach((x) => (x.isVisible = x.isVisible == undefined ? true : x.isVisible));
    }

    return result;
  });

  const visibleColumns = computed(() =>
    allColumns.value.filter(
      (x) =>
        (columnsFromUserPreference.value.length &&
          columnsFromUserPreference.value.find((y) => y.name == x.field)?.isColumnVisible) ||
        (!columnsFromUserPreference.value.length && x.isVisible != false)
    )
  );

  const array_move = (arr: any[], old_index: number, new_index: number) => {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  };

  const setColumnPosition = (oldPosition: number, newPosition: number) => {
    let allCols = [...allColumns.value];
    array_move(allCols, oldPosition - 1, newPosition - 1);

    saveUserPreference({
      preferenceKey: key.value,
      preferenceValue: JSON.stringify(allCols.map((x) => new AppTableColumnSelection(x.field as string, x.isVisible))),
    });
  };

  return {
    key,
    allColumns,
    visibleColumns,
    setColumnPosition,
    columnsFromUserPreference,
  };
};
